import { render, staticRenderFns } from "./createFranchise.vue?vue&type=template&id=4322ae4b&"
import script from "./createFranchise.vue?vue&type=script&lang=js&"
export * from "./createFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports